import './server-error-screen.scss';
import template from './server-error-screen.html';

export default angular
  .module('doxy.common.components.serverErrorScreen', [])
  .component('serverErrorScreen', {
    template,
    bindings: {},
    controller: function ($scope, $window) {
      let serverWorkingOnStart = false;

      this.showError = false;
      this.errorWasShown = +localStorage.getItem('serverErrorWasShown') || 0;

      this.reloadPage = () => {
        $window.location.reload();
      };

      $scope.$on('http:error:500', () => {
        if (serverWorkingOnStart || this.showError) return;
        localStorage.setItem('serverErrorWasShown', ++this.errorWasShown);
        this.showError = true;
      });

      $scope.$on('$stateChangeSuccess', () => {
        localStorage.removeItem('serverErrorWasShown');
        serverWorkingOnStart = true;
      });
    },
  }).name;
